import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { produce } from 'immer';

import {
  FieldValidationResultType,
  OrderType,
  PostPaymentOrderError,
  PostPaymentOrderRequest,
  PostPaymentOrderResponse,
} from '@dtp/membership-service-types';

// Actions
export enum Actions {
  CREATE_ORDER = 'naf/loggedInActivationOrder/CREATE_ORDER',
  CREATE_ORDER_SUCCESS = 'naf/loggedInActivationOrder/CREATE_ORDER_SUCCESS',
  CREATE_ORDER_FAIL = 'naf/loggedInActivationOrder/CREATE_ORDER_FAIL',
  CREATE_ORDER_CANCEL = 'naf/loggedInActivationOrder/CREATE_ORDER_CANCEL',
}

export interface State {
  salesOrder?: OrderType;
  validation?: PostPaymentOrderError;
  isCreatingOrder: boolean;
  orderDetails?: PostPaymentOrderResponse;
  isCreated: boolean;
}

export const initialState: State = {
  salesOrder: {
    customerProductsRequests: [],
    returnUrl: '',
  },
  isCreated: false,
  isCreatingOrder: false,
};

export const actions = {
  createOrder: createAsyncAction(
    Actions.CREATE_ORDER, // request payload creator
    Actions.CREATE_ORDER_SUCCESS, // success payload creator
    Actions.CREATE_ORDER_FAIL, // failure payload creator
    Actions.CREATE_ORDER_CANCEL, // optional cancel payload creator
  )<PostPaymentOrderRequest, PostPaymentOrderResponse, PostPaymentOrderError, undefined>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.createOrder.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isCreatingOrder = true;
      delete draftState.validation;
    }),
  )
  .handleAction(actions.createOrder.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isCreatingOrder = false;
      draftState.isCreated = true;
      draftState.orderDetails = action.payload;
    }),
  )
  .handleAction(actions.createOrder.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isCreatingOrder = false;
    }),
  )
  .handleAction(actions.createOrder.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isCreatingOrder = false;
      draftState.isCreated = false;
      draftState.validation = action.payload;
      draftState.validation.validationMap = action.payload.validationResults.reduce(
        (acc: Record<FieldValidationResultType['field'], FieldValidationResultType>, cur) => {
          acc[cur.field] = cur;
          return acc;
        },
        {},
      );
    }),
  );
